import {STATE} from '../classes/Enum';
import {CartItem} from '../classes/Item';
import { serializeWishItem } from './products';
import { removeFromWishlist, addToWishlist } from '../api/user';
import { useAuth } from '../components/AuthProvider';

export function getCartQuantity(cart, itemId, variant = "", condition = null) {

  if (condition === null) {
    const count = cart
      .filter(cItem => cItem.productId === itemId)
      .reduce((sum, cItem) => sum + cItem.count, 0);

    return count;
  }


    const cartItem = cart.find(cItem => cItem.productId === itemId
      && cItem.variant === variant
      && cItem.condition === condition
    );
    const count = cartItem ? cartItem.count : 0;
    return count;
}

export function getProduct(products, id) {
    return products.find(product => product.id === id);
}

export function addToCart(cart, setCart, product, variant = "", condition = null) {
    if (product.type === STATE.CARD) {
      let availableQuantity =
        product.conditionQuantities?.[variant]?.[condition]?.quantity || 0;

      if (availableQuantity <= 0) return;
      const existingItemIndex = cart.findIndex(cartItem =>
        cartItem.productId === product.id &&
        cartItem.condition === condition &&
        cartItem.variant === variant
      );

      if (existingItemIndex >= 0) {
        if (cart[existingItemIndex].count < availableQuantity) {
          const updatedCart = [...cart];
          updatedCart[existingItemIndex].count += 1;
          setCart(updatedCart);
        }
      }
      else {
        const newCartItem = new CartItem(product.id, condition, variant, 1, product.type);
        setCart([...cart, newCartItem]);
      }
    } else {
      const existingItemIndex = cart.findIndex(cartItem =>
        cartItem.productId === product.id
      );

      if (product.quantity <= 0) return;

      if (existingItemIndex >= 0) {
        const updatedCart = [...cart];
        if (cart[existingItemIndex].count < product.quantity) {
          updatedCart[existingItemIndex].count += 1;
          setCart(updatedCart);
        }
        else {
          updatedCart[existingItemIndex].count = product.quantity;
          setCart(updatedCart);
        }
      } else {
        const newCartItem = new CartItem(product.id, null, null, 1, product.type);
        setCart([...cart, newCartItem]);
      }
    }
  }

  export function getTitle(state) {
    if (state === STATE.OVERVIEW) {
      return "WELCOME";
    }
    if (state === STATE.CARD) {
      return 'SINGLES';
    }
    if (state === STATE.PACK) {
      return 'BOOSTERS';
    }
    if (state === STATE.PROMOTION) {
      return 'PROMOTIONS';
    }
    if (state === STATE.SLAB) {
      return 'SLABS';
    }
    if (state === STATE.ADMIN_TOOLS) {
      return 'INVENTORY ADMIN';
    }
    if (state === STATE.COLLECTIONS) {
      return 'Profile';
    }
    if (state === STATE.COUPONS) {
      return 'Coupons';
    }
    if (state === STATE.PROFILE) {
      return 'Account';
    }
    if (state === STATE.ORDERS) {
      return 'Orders';
    }
    return state;
  }

  export function getDescription(state, user) {

    if (state === STATE.OVERVIEW) {
      return "Discover a world of cards at your fingertips. Buy and collect like you've never before.";
    }
    if (state === STATE.CARD) {
      return 'Browse singles like never before with our intuitive interface, designed to make finding your next card a breeze.';
    }
    if (state === STATE.PACK) {
      return 'Just one pack wouldn\'t hurt..';
    }
    if (state === STATE.PROMO) {
      return 'Includes Bilbo\'s range of limited promotions, and card accessories!';
    }
    if (state === STATE.SLAB) {
      return 'We\'re on a whole notta level!';
    }
    if (state === STATE.SEALED) {
      return 'Should I open it or keep it sealed!?';
    }
    if (state === STATE.ADMIN_TOOLS) {
      return 'Scan QR codes, receive stock, and update prices.';
    }
    if (state === STATE.COLLECTIONS) {
      let name = user?.firstName || 'User';

      return 'Hey ' + name;
    }
    return "";
  }

  export async function toggleWish(isWished, setWishlist, itemId) {
    if (isWished) {
      removeFromWishlist(itemId);
      setWishlist(prev =>
        prev.filter(w => w.cardId !== itemId)
      );
      return;
    }

    const wishedItem = await addToWishlist(itemId);
    const serializedItem = serializeWishItem(wishedItem);
    setWishlist(prev => {
      // prevent duplicates
      if (prev.some(w => w.card_id === serializedItem.cardId)) return prev;
      return [...prev, serializedItem];
    });
  }